export default {
    curriculums:                    { method: 'get',    url: 'curriculums' },
    curriculumStatus:               { method: 'get',    url: 'curriculums/status' },
    curriculumSequencies:           { method: 'get',    url: 'curriculums/sequencies' },
    curriculumRegimes:              { method: 'get',    url: 'curriculums/regimes' },
    createCurriculum:               { method: 'post',   url: 'curriculums'},
    updateCurriculum:               { method: 'put',    url: 'curriculums/{id}'},
    deleteCurriculum:               { method: 'delete', url: 'curriculums/{id}'},
    updateCurriculumDisciplines:    { method: 'put',    url: 'curriculums/{id}/update/disciplines'},
    disableGlobalPrereq:            { method: 'post',   url: 'curriculums/{id}/disabled-global-prereqs'},
    enableGlobalPrereq:             { method: 'delete', url: 'curriculums/{id}/disabled-global-prereqs/{disciplineId}/{requiredId}'},
}